import React from "react";
import { useLoaderData } from "react-router-dom";
import TopCollectionCard from "./TopCollectionCard";

const TopCollection = () => {
  const collection = useLoaderData();
  return (
    <div className="max-w-6xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-10">
        {collection.map((collectionData) => (
          <TopCollectionCard
            key={collectionData._id}
            collectionData={collectionData}

          ></TopCollectionCard>
        ))}
      </div>
      
    </div>
  );
};

export default TopCollection;
